import { NgFor, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, computed, signal } from '@angular/core';

interface LogItem {
  srNo: number;
  dateTime: string;
  loginId: string;
  subject: string;
  description: string;
  icon: 'purchase' | 'barcode' | 'sell' | 'update' | 'product';
}

@Component({
  selector: 'app-logs',
  imports: [NgFor, NgSwitchCase, NgSwitch],
  templateUrl: './logs.component.html',
  styleUrl: './logs.component.css',
})
export class LogsComponent {
  // firm
  items = ['Firm 1', 'Firm 2', 'Firm 3'];

  logs = signal<LogItem[]>([
    {
      srNo: 17157,
      dateTime: '10 Dec 2025 17:28:09',
      loginId: '-',
      subject: 'Customer Purchase',
      description: 'Pur Inv No: IS10384, Date: 10 Dec 2025',
      icon: 'purchase',
    },
    {
      srNo: 17158,
      dateTime: '10 Dec 2025 17:30:10',
      loginId: '-',
      subject: 'Barcode Item Added',
      description: 'Gold Item Id: Bracelet 12, Valuation: 99,895.00',
      icon: 'barcode',
    },
    {
      srNo: 17159,
      dateTime: '10 Dec 2025 17:32:45',
      loginId: '-',
      subject: 'New Sell Inv Generated',
      description: 'Sell Invoice Generated',
      icon: 'sell',
    },
    {
      srNo: 17160,
      dateTime: '10 Dec 2025 17:32:45',
      loginId: '-',
      subject: 'Stock Item Updated',
      description:
        'Gold Item Id:  Ring 12, Date: 10 Dec 2025, Valuation: 99,895.00',
      icon: 'update',
    },
    {
      srNo: 17161,
      dateTime: '10 Dec 2025 17:32:45',
      loginId: '-',
      subject: 'Product Added',
      description:
        'Transaction Id: Transaction Amount: 13650, Transaction Date: 10 Dec 2025',
      icon: 'product',
    },
    {
      srNo: 17162,
      dateTime: '10 Dec 2025 17:28:09',
      loginId: '-',
      subject: 'Customer Purchase',
      description: 'Pur Inv No: IS10384, Date: 10 Dec 2025',
      icon: 'purchase',
    },
    {
      srNo: 17163,
      dateTime: '10 Dec 2025 17:30:10',
      loginId: '-',
      subject: 'Barcode Item Added',
      description: 'Gold Item Id: Bracelet 12, Valuation: 99,895.00',
      icon: 'barcode',
    },
    {
      srNo: 17164,
      dateTime: '10 Dec 2025 17:32:45',
      loginId: '-',
      subject: 'New Sell Inv Generated',
      description: 'Sell Invoice Generated',
      icon: 'sell',
    },
    {
      srNo: 17165,
      dateTime: '10 Dec 2025 17:32:45',
      loginId: '-',
      subject: 'Stock Item Updated',
      description:
        'Gold Item Id:  Ring 12, Date: 10 Dec 2025, Valuation: 99,895.00',
      icon: 'update',
    },
    {
      srNo: 17166,
      dateTime: '10 Dec 2025 17:32:45',
      loginId: '-',
      subject: 'Product Added',
      description:
        'Transaction Id: Transaction Amount: 13650, Transaction Date: 10 Dec 2025',
      icon: 'product',
    },
    {
      srNo: 17167,
      dateTime: '10 Dec 2025 17:32:45',
      loginId: '-',
      subject: 'Product Added',
      description:
        'Transaction Id: Transaction Amount: 13650, Transaction Date: 10 Dec 2025',
      icon: 'product',
    },
  ]);

  // Pagination state
  pageSize = signal(15);
  currentPage = signal(1);

  totalPages = computed(() => Math.ceil(this.logs().length / this.pageSize()));
  pages = computed(() =>
    Array.from({ length: this.totalPages() }, (_, i) => i + 1)
  );
  paginatedLogs = computed(() => {
    const start = (this.currentPage() - 1) * this.pageSize();
    return this.logs().slice(start, start + this.pageSize());
  });

  // Pagination actions
  nextPage() {
    if (this.currentPage() < this.totalPages()) {
      this.currentPage.update((p) => p + 1);
    }
  }

  prevPage() {
    if (this.currentPage() > 1) {
      this.currentPage.update((p) => p - 1);
    }
  }

  goToPage(page: number) {
    this.currentPage.set(page);
  }
  trackBySrNo(index: number, item: LogItem) {
    return item.srNo;
  }
}
